<template>
    <MainContent>
        <template v-slot:header>
          <PageTitle v-if="envio" :title="'Detalles del pedido Nº ' + envio.n_pedido"></PageTitle>
        </template>
        <template v-slot:content>
            <div class="table-responsive has-options">
                <table class="table table-hover text-nowrap">
                    <thead>
                        <tr>
                            <th>Nº ABONADO</th>
                            <th>NOMBRE</th>
                            <th>APELLIDOS</th>
                            <th>DNI</th>
                            <th>EMAIL</th>
                            <th>TELÉFONO</th>
                            <th class="text-center">CÓDIGO POSTAL</th>
                        </tr>
                    </thead>
                    <tbody v-if="!loading">
                        <template v-for="(abonado, index) in envio.abonados">
                            <tr :key="index">
                                <td>{{ abonado.n_abonado }}</td>
                                <td>{{ abonado.name }}</td>
                                <td>{{ abonado.surnames }}</td>
                                <td>{{ abonado.dni }}</td>
                                <td>{{ abonado.email }}</td>
                                <td>{{ abonado.telefono }}</td>
                                <td class="text-center">{{ abonado.cp }}</td>
                            </tr>
                        </template>
                    </tbody>
                    <tbody v-else>
                        <tr>
                            <td colspan="6">
                                <LoaderComponent></LoaderComponent>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </template>
    </MainContent>   
</template>

<script>
import MainContent from "@/components/backend/components/MainContent";
import PageTitle from '@/components/backend/components/PageTitleComponent';

export default {
    props: ['envio_id'],
    data() {
        return {
            loading: true,
            envio: null,
        }
    },
    created() {
        this.getEnvio();
    },
    methods: {
        getEnvio: function() {
            this.loading = true;

            const params = {
                envio_id: this.envio_id
            };

            this.$store.dispatch(this.config.getVuexAlias('back.envios.show'), params).then(res => {
                this.envio = res.data.data;
            }).finally(() => this.loading = false);
        }
    },
    components: {
        MainContent, PageTitle
    }
}
</script>